export const namespace = 'layout';
export const SET_OPEN_SIDEBAR = `${namespace}/setOpenSidebar`;
